import React from "react";
import "./yourCompany.scss";

//Imagens:
import ImgYourCompany from "../../../../assets/industry/industry.png";
import SectionComponent from "../../../../components/utils/SectionComponent";
import { useTranslation } from "react-i18next";


function YourCompany() {
  const { t } = useTranslation()

  return (
    <div className="container-your-company">
      <div className="img-your-company">
        <img src={ImgYourCompany} alt="" />
      </div>
      <div className="texts-your-company">
        <SectionComponent title={t("industry.title")} text={t("industry.section_text_1")}>
          <p>{t("industry.section_text_2")}</p>
        </SectionComponent>

        <a href="/form">
          <button id="btn-your-company">{t("buttons.demo_btn_alternative_text_1")}</button>
        </a>
      </div>
    </div>
  );
}

export default YourCompany;
